export default __webpack_public_path__ + "static/media/warning-icon.c32132f7.svg";